import { MouseEvent, ReactNode, useCallback } from "react";
import { Link, useNavigate } from "react-router";

import classNames from "classnames";
import styles from "./Error404Page.module.css";

import { ReactComponent as DirigibleCrash } from "./assets/404-dirigible.svg";
import { ReactComponent as Ground } from "./assets/ground.svg";
import { useModulePathResolver } from "./hooks";

/** The `Error404Page` component properties. */
export interface Error404PageProps {
  /** The CSS class name. */
  readonly className?: string;
}

/** A component which displays the content of the 404 error page. */
export const Error404Page = (props: Error404PageProps): ReactNode => {
  const { className } = props;

  const modulePath = useModulePathResolver();
  const navigate = useNavigate();

  const backHandler = useCallback((ev: MouseEvent<HTMLAnchorElement>) => {
    ev.preventDefault();
    navigate(-1);
  }, []);

  return (
    <div className={classNames(styles.root, "pageNotFound", className)}>
      <div className="errBlock">
        <p className={classNames(styles.errorCode, "errCode")}>404</p>
        <p className={classNames(styles.errorMessage, "errMsg")}>
          Mission failure, this page doesn’t exist!
          <br />
          Let’s go{" "}
          <a href="#" onClick={backHandler}>
            {" "}
            back{" "}
          </a>{" "}
          to safety. Or all the way <Link to={modulePath("/")}>home</Link>.
        </p>
      </div>
      <DirigibleCrash />
      <div className={classNames(styles.errorBackground, "background")}>
        <Ground className={classNames(styles.errorGround, "ground")} />
      </div>
    </div>
  );
};
